module.exports = __webpack_public_path__ + "static/img/5-2.b4d541f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-5/5-2.jpg
// module id = 744
// module chunks = 1